import { useMemo } from 'react';

export const useAvailableYears = () => {
  const currentYear = new Date().getFullYear();

  return useMemo(() => {
    const startYear = 2018;
    const endYear = currentYear;
    const length = endYear - startYear + 1;
    return Array.from({ length }, (_, i) => startYear + i);
  }, [currentYear]);
};
